import { render, staticRenderFns } from "./rank-list.vue?vue&type=template&id=a3578530&scoped=true&"
import script from "./rank-list.vue?vue&type=script&lang=js&"
export * from "./rank-list.vue?vue&type=script&lang=js&"
import style0 from "./rank-list.vue?vue&type=style&index=0&id=a3578530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3578530",
  null
  
)

export default component.exports